import _get from 'lodash/get';

export const isFunctionBusyError = error => {
  const status = _get(error, 'status');
  const errorType = _get(error, 'errorType') || _get(error, 'errors[0].type');
  return (status === 400 || status === 'fail') && errorType === 'FunctionBusy';
};
